import { useRef, useState } from "react";
import $ from 'jquery';

// react-pintura
import { PinturaEditor } from "@pqina/react-pintura";

// pintura
import "@pqina/pintura/pintura.css";
import { getEditorDefaults } from "@pqina/pintura";
import { NavLink } from "react-router-dom";
import { textmapping } from "../helper";
export default function Pintura(props) {
  const editorRef = useRef(null);
  // inline result
  const [result, setResult] = useState("");
  const [backimage, setBackImage] = useState('');

  // get default properties
  const editorDefaults = getEditorDefaults({
    stickers: ["😎"],
  });

  const readFile = (e) => {};

  // console.log(props);

  return (
    <div>
      {/* <h2>Defaults</h2> */}
      <section>
        <div className="container" style={{ marginBottom: "50px" }}>
          <div className="wall_content_container">
            <div className="selectimage_bg">
              <NavLink to={"/" + window.location.search} className="">
                <img
                  src="/assets/images/backarrowbg.svg"
                  className="mobile_back"
                  alt=""
                />
                <img
                  src="/assets/images/backarrow.svg"
                  className="desk_back"
                  alt=""
                />
              </NavLink>
              <div className="pintura_img" style={{ height: "70vh" }}>
                <PinturaEditor
                  {...editorDefaults}
                  ref={editorRef}
                  utils={["sticker"]}
                  onSelectshape={(re)=>{setBackImage(re.backgroundImage)}}
                  // onSelectshape={(re)=>{console.log(re);}}
                  // onRemoveshape={(res)=>{console.log(res);}}
                  onRevert={()=>{setBackImage('')}}
                  src={props.monumentImage}
                  // stickerStickToImage={true}
                  // stickerEnableSelectImagePreset={true}
                  
                  imageCropAspectRatio={1}
                  stickers={[
                    [
                      "Markers",
                      [
                        {
                          src: props.userImage,
                          width: "50%",
                          alt: "One",
                          disabled:backimage?true:false
                        },
                      ],
                    ],
                  ]}
                  stickerEnableSelectImage={false}
                  onLoad={(res) => {
                  }}
                  onProcess={({ dest }) => {
                    if(backimage){

                      props.getFinalPintura(dest);
                    }else{
                      $(".error_popupbg").show();
                      $(".textp").text(
                        textmapping("please select your image.", props.lang)
                      );
                    }
                    // setResult(URL.createObjectURL(dest))
                  }}
                />
              </div>
              <div className="container">
                {!!result.length && (
                  <p>
                    <img src={result} className="monument_radius" alt="" />
                  </p>
                )}
                {/* <input type="file"  onChange={(e)=>{readFile(e)}}/> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
